import { HeartTick, MedalStar, TagUser, Truck } from 'iconsax-reactjs';
import { useTranslation } from 'react-i18next';

import UspItem from '~/components/usp/UspItem';

const Usp = () => {
  const { t } = useTranslation();

  return (
    <section className="usp">
      <div className="usp__container">
        <UspItem
          icon={<MedalStar size="24" color="#ffffff" variant="Outline" />}
          title={t('components.usp.items.0.title')}
          description={t('components.usp.items.0.description')}
        />
        <UspItem
          icon={<HeartTick size="24" color="#ffffff" variant="Outline" />}
          title={t('components.usp.items.1.title')}
          description={t('components.usp.items.1.description')}
        />
        <UspItem
          icon={<Truck size="24" color="#ffffff" variant="Outline" />}
          title={t('components.usp.items.2.title')}
          description={t('components.usp.items.2.description')}
        />
        <UspItem
          icon={<TagUser size="24" color="#ffffff" variant="Outline" />}
          title={t('components.usp.items.3.title')}
          description={t('components.usp.items.3.description')}
        />
      </div>
    </section>
  );
};

export default Usp;
